// extracted by mini-css-extract-plugin
module.exports = {"headingField":"DateWrapper_headingField__1rnng","error":"DateWrapper_error__2x2-a","date":"DateWrapper_date__36X5l"};